import React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

function DetailsItems(props) {
    const items = props.items || [];

    return(
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Internal SKU</TableCell>
                    <TableCell>External SKU</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Internal Price</TableCell>
                    <TableCell>External Price</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {items.map((item, index) => {
                    return(
                        <TableRow key={index}>
                            <TableCell>{item.internal_sku}</TableCell>
                            <TableCell>{item.external_sku || "N/A"}</TableCell>
                            <TableCell>{item.quantity}</TableCell>
                            <TableCell>{item.internal_price ? `$${item.internal_price}` : "-"}</TableCell>
                            <TableCell>${item.external_price}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    )
}

export default DetailsItems;